import { PropsWithChildren } from "react";
import { StyledLink, StyledNavLink } from "./drawer.styles";
import { useDrawerContext } from "./DrawerContextProvider";

type DrawerLinkItemProps = PropsWithChildren<{
  path: string;
}>;

export const DrawerLinkItem = ({ path, children }: DrawerLinkItemProps) => {
  const { isDrawerOpen } = useDrawerContext();

  return (
    <StyledNavLink to={path} $isDrawerOpen={isDrawerOpen}>
      {children}
    </StyledNavLink>
  );
};

export const DrawerExternalLinkItem = ({
  path,
  children,
}: DrawerLinkItemProps) => {
  const { isDrawerOpen } = useDrawerContext();

  return (
    <StyledLink
      href={path}
      target="_blank"
      rel="noopener noreferrer"
      $isDrawerOpen={isDrawerOpen}
    >
      {children}
    </StyledLink>
  );
};
